import { IChangePortionPositionContext } from './changePortionPositionContext';

export enum ChangePortionPositionActionTypes {
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_RESTAURANT = 'SET_RESTAURANT',
	SET_ID_DISH = 'SET_ID_DISH',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_POSITIONS_DATA = 'SET_POSITIONS_DATA',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL = 'SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL',
	TOGGLE_APPLY_TO_ONE = 'TOGGLE_APPLY_TO_ONE',
	SET_ADDITIONAL_RESTAURANTS = 'SET_ADDITIONAL_RESTAURANTS',
	CHANGE_SELECT_SEARCH_STRING = 'CHANGE_SELECT_SEARCH_STRING',
}

interface ISetIDCustomer {
	type: ChangePortionPositionActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IChangePortionPositionContext['IDSelectedCustomer'];
	};
}

interface ISetRestaurant {
	type: ChangePortionPositionActionTypes.SET_RESTAURANT;
	payload: {
		selectedRestaurant: IChangePortionPositionContext['selectedRestaurant'];
	};
}

interface ISetIDDish {
	type: ChangePortionPositionActionTypes.SET_ID_DISH;
	payload: {
		IDSelectedDish: IChangePortionPositionContext['IDSelectedDish'];
	};
}

interface IResetSelectedControls {
	type: ChangePortionPositionActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetPositionsData {
	type: ChangePortionPositionActionTypes.SET_POSITIONS_DATA;
	payload: {
		positionsData: IChangePortionPositionContext['positionsData'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ChangePortionPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IChangePortionPositionContext['typeOfModalWindow'];
	};
}

interface ISetVisibleAdditionalRestaurantsModal {
	type: ChangePortionPositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL;
	payload: {
		isVisibleAdditionalRestaurantsModal: IChangePortionPositionContext['isVisibleAdditionalRestaurantsModal'];
		isApplyToOne: IChangePortionPositionContext['isApplyToOne'];
		selectedAdditionalRestaurants: IChangePortionPositionContext['selectedAdditionalRestaurants'];
		selectSearchString: IChangePortionPositionContext['selectSearchString'];
	};
}

interface IToggleApplyToOne {
	type: ChangePortionPositionActionTypes.TOGGLE_APPLY_TO_ONE;
}

interface ISetAdditionalRestaurants {
	type: ChangePortionPositionActionTypes.SET_ADDITIONAL_RESTAURANTS;
	payload: {
		selectedAdditionalRestaurants: IChangePortionPositionContext['selectedAdditionalRestaurants'];
	};
}

interface IChangeSelectSearchString {
	type: ChangePortionPositionActionTypes.CHANGE_SELECT_SEARCH_STRING;
	payload: {
		selectSearchString: IChangePortionPositionContext['selectSearchString'];
	};
}

export type TChangePortionPositionActions =
	| ISetIDCustomer
	| ISetRestaurant
	| ISetIDDish
	| IResetSelectedControls
	| ISetPositionsData
	| IChangeTypeOfModalWindow
	| ISetVisibleAdditionalRestaurantsModal
	| IToggleApplyToOne
	| ISetAdditionalRestaurants
	| IChangeSelectSearchString;
